const LETTER_BUTTON_DATA_ATTRIBUTE = '[data-element="letters-buttons"]';

class LettersButtons {
  constructor(lettersButtonsList) {
    const lettersButtons = lettersButtonsList.children;

    Array.from(lettersButtons).forEach((lettersButton) => {
      const link = lettersButton.getAttribute('href').slice(1);

      const referredSection = document.getElementById(link);

      if (referredSection === null) {
        lettersButton.setAttribute('disabled', '');
        lettersButton.setAttribute('tabindex', '-1');
      }
    });
  }
}

const initializeLettersButtons = () => {
  document.querySelectorAll(LETTER_BUTTON_DATA_ATTRIBUTE).forEach((lettersButtonsList) => new LettersButtons(lettersButtonsList));
};

export {
  LettersButtons,
  initializeLettersButtons,
};